'use client';

import { useTranslation } from 'react-i18next';

import type { Either } from '@sola/schema/dotcom/helpers.ts';

import type {
  InputFieldProps,
  InputFieldWithAriaLabel,
  InputFieldWithLabel,
  InputFieldWithoutLabel,
} from '../input-field/input-field.tsx';
import { InputField } from '../input-field/input-field.tsx';

export type EmailFieldProps = Either<
  InputFieldWithLabel,
  Either<InputFieldWithAriaLabel, InputFieldWithoutLabel>
> &
  Omit<
    InputFieldProps,
    'type' | 'inputMode' | 'step' | 'pattern' | 'spellCheck' | 'autoCorrect'
  >;

export const EmailField: React.FC<EmailFieldProps> = ({ ...fieldProps }) => {
  const { t } = useTranslation(['forms']);
  return (
    <InputField
      type="email"
      autoComplete="email"
      autoCapitalize="off"
      pattern={{
        value:
          // = * & ^ % $ # ! valid email characters but backend can't accept them
          /^$|^[\w'+/?_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,63})$/,
        message: t('forms:errors.invalidEmail'),
      }}
      {...fieldProps}
    />
  );
};
